import React from "react";
import { Home, Wallet, ShieldCheck, Star } from "lucide-react";

const items = [
  { icon: Home, label: "25+ Homes Bought" },
  { icon: Wallet, label: "$5M+ Cash Deployed" },
  { icon: ShieldCheck, label: "Local & Family-Owned" },
  { icon: Star, label: "4.9 / 5 Seller Rating" },
];

export default function TrustTicker() {
  return (
    <section
      data-testid="trust-ticker"
      className="border-b border-[var(--c4p-line)] bg-[var(--c4p-cream)]"
    >
      <div className="mx-auto max-w-7xl px-6 py-6 lg:px-10">
        <div className="stats-bar">
          {items.map((it, i) => (
            <div
              key={i}
              className={`flex items-center justify-center gap-2.5 px-4 py-3 ${
                i < items.length - 1 ? "md:border-r md:border-[var(--c4p-line)]" : ""
              }`}
            >
              <it.icon size={18} className="text-[var(--c4p-orange)]" />
              <span className="font-sans-ui text-[14px] font-semibold text-[var(--c4p-ink)]">
                {it.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
